  "use client";

  import "./css/Videos.css";

  // Importa los 5 videos
  import v1 from "../vds/1.mp4";
  import v2 from "../vds/2.mp4";
  import v3 from "../vds/3.mp4";
  import v4 from "../vds/4.mp4";
  import v5 from "../vds/5.mp4";

  const Videos = () => {
    const videos = [v1, v2, v3, v4, v5];

    return (
      <section className="Videos-section" id="Videos">
        <div className="videos-grid">
          {videos.map((src, idx) => (
            <div className="video-card" key={idx}>
              <video
                className="video"
                src={src}
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
              >
                Tu navegador no soporta la etiqueta de video.
              </video>
            </div>
          ))}
        </div>
      </section>
    );
  };

  export default Videos;
